import { useEffect, useState } from "react";
import { getDashboardMtClinic, updateExamCounselStatus } from "../../../api/dashboard.api";
import useAxios from "../../../hooks/useAxios";
import { IClass } from "../../../models/campusClasses.model";
import { IDashboardMtClinic, IGetDashboardMtClinic } from "../../../models/dashboard.model";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import ErrorResponse from "../../ErrorResponse";
import Loader from "../../Loader";
import { getCommonCodeLabel } from "../../../lib/store";
import { Select } from "antd";
import { creatMenuAccessLog } from "../../../api/systemLog.api";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/rootReducer";
import { DATE_FORMAT } from "../../../constans";
import useNotification from "../../../hooks/useNotification";

const { Option } = Select;

const Block = styled.div`
  .table-custom {
    border-top: 0px;
  }
  
  .table-scroll-wrapper {
    overflow-x: auto;
    width: 100%;
  }
  
  .table-scroll-wrapper table {
    min-width: 1500px;
  }

  .table-scroll-wrapper::-webkit-scrollbar {
    height: 6px;
    width: 4px;
  }
`;

interface IProps {
    classData: IClass | undefined;
}

const Management = ({ classData }: IProps) => {

    const CRITERIA_ELEARNING_STATUS = 80;
    const DISPLAY_PERCENT_DECIMAL = 1;
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    const { successNotification, errorNotification, infoNotification } = useNotification();
    const { data: res, isLoading, error, execute } = useAxios<IGetDashboardMtClinic>();
    const [mtClinicDataList, setMtClinicDataList] = useState<IDashboardMtClinic[]>([]);
    
    // MB0008 = MT_CLINIC상담구분
    const CL0007 = commonCodes.find(item => item.commonCode === 'CL0007')?.detailCode;

    const parsePercent = (targetCount: number, allCount: number) => {
        if (allCount === null || allCount === undefined || allCount === 0) {
            return 0;
        }
        if (targetCount === null || targetCount === undefined) {
            return 0;
        }
        return (targetCount / allCount) * 100;
    };
    
    const checkZeroCount = (targetCount: number, allCount: number) => {
        return (allCount === 0 || allCount === null || allCount === undefined) && 
               (targetCount === 0 || targetCount === null || targetCount === undefined);
    };

    const calculatePercent = (targetCount: number, allCount: number): number | null => {
        if (allCount === null || allCount === undefined || allCount === 0) {
            return null;
        }
        if (targetCount === null || targetCount === undefined) {
            return null;
        }
        const percent = parsePercent(targetCount, allCount);
        const isZeroCount = checkZeroCount(targetCount, allCount);
    
        if(isZeroCount || isNaN(percent)) {
            return null;
        }
        return percent;
    };

    const displayElearningPercent = (percent: number | null) => {
        if (percent === null) {
            return '-';
        } else if (percent === 0) {
            return '0%';
        } else {
            return percent.toFixed(DISPLAY_PERCENT_DECIMAL) + '%';
        }
    }

    const calculateWeeklyBookReadAverage = (bookCount: number, days: number) => {
        if (days === 0) return '-';
        const weeklyAvg = bookCount / (days / 7);
        return weeklyAvg.toFixed(1); // 소수 첫째자리까지 반환
    };

    useEffect(() => {
        getClassDashboardData();
    }, [classData]);

    useEffect(() => {
        if (res && !isLoading) {
            let tempDataList : IDashboardMtClinic[]  = _.cloneDeep(res.data);

            if (tempDataList.length > 0) {
                tempDataList.forEach((item: IDashboardMtClinic) => {
                    item.icoachingRate = calculatePercent(item.icoachingCompleteCount, item.icoachingCount);
                    item.elearningRate = calculatePercent(item.elearningCompleteCount, item.elearningCount);
                    item.totalBookDaysRate = calculateWeeklyBookReadAverage(item.totalBookCount, item.totalDays);

                    //mt1
                    if(item.mt1AssessLevel === 'Developing') {
                        if (item.mt1TotalVideo > 0) {
                            item.mt1VideoDisplay = item.mt1VideoComplete + '/' + item.mt1TotalVideo;
                        } else {
                            item.mt1VideoDisplay = '-';
                        }
                    } else {
                        item.mt1VideoDisplay = '-';
                    }

                    if(item.mt1AssessLevel === 'Developing' || item.mt1AssessLevel === 'On') {
                        if (item.mt1TotalReview > 0) {
                            item.mt1ReviewDisplay = item.mt1ReviewComplete + '/' + item.mt1TotalReview;
                        } else {
                            item.mt1ReviewDisplay = '-';
                        }
                    } else {
                        item.mt1ReviewDisplay = '-';
                    }

                    if(item.mt1AssessLevel === 'On') {
                        if (item.mt1TotalSkillPractice > 0) {
                            item.mt1SkillPracticeDisplay = item.mt1SkillPracticeComplete + '/' + item.mt1TotalSkillPractice;
                        } else {
                            item.mt1SkillPracticeDisplay = '-';
                        }
                    } else {
                        item.mt1SkillPracticeDisplay = '-';
                    }

                    //mt2
                    if(item.mt2AssessLevel === 'Developing') {
                        if (item.mt2TotalVideo > 0) {
                            item.mt2VideoDisplay = item.mt2VideoComplete + '/' + item.mt2TotalVideo;
                        } else {
                            item.mt2VideoDisplay = '-';
                        }
                    } else {
                        item.mt2VideoDisplay = '-';
                    }

                    if(item.mt2AssessLevel === 'Developing' || item.mt2AssessLevel === 'On') {
                        if (item.mt2TotalReview > 0) {
                            item.mt2ReviewDisplay = item.mt2ReviewComplete + '/' + item.mt2TotalReview;
                        } else {
                            item.mt2ReviewDisplay = '-';
                        }
                    } else {
                        item.mt2ReviewDisplay = '-';
                    }

                    if(item.mt2AssessLevel === 'On') {
                        if (item.mt2TotalSkillPractice > 0) {
                            item.mt2SkillPracticeDisplay = item.mt2SkillPracticeComplete + '/' + item.mt2TotalSkillPractice;
                        } else {
                            item.mt2SkillPracticeDisplay = '-';
                        }
                    } else {
                        item.mt2SkillPracticeDisplay = '-';
                    }
                });
                setMtClinicDataList(tempDataList);
            }
        }
    }, [res, isLoading]);

    const getClassDashboardData = () => {
        if (classData) {
            execute(getDashboardMtClinic(classData.campusCode, classData.classCode));
            //execute(getDashboardMtClinic(classData.campusCode, 'CB00004803'));
        }
    }

    const handleCounselStatusChange = async (
        classStudentCode: number,
        examTestCode: number,
        counselStatus: string,
        examType: 'mt1' | 'mt2' | 'mt3' | 'tt'
    ) => {
        try {
            const form = new FormData();
            form.append('examTestCode', String(examTestCode));
            form.append('classStudentCode', String(classStudentCode));
            form.append('counselStatus', counselStatus);

            const result = await updateExamCounselStatus(form);

            if(result?.data?.data && result?.data?.data > 0) {
                setMtClinicDataList(prevList => 
                    prevList.map(item => {
                        if (item.classStudentCode === classStudentCode) {
                            if(examType === 'mt1') {
                                item.mt1CounselStatus = counselStatus;
                            } else if(examType === 'mt2') {
                                item.mt2CounselStatus = counselStatus;
                            } else if(examType === 'mt3') {
                                item.mt3CounselStatus = counselStatus;
                            } else if(examType === 'tt') {
                                item.ttCounselStatus = counselStatus;
                            }
                        }
                        return item;
                    })
                );
                
                successNotification(t('common.message.save1'));
            } else {
                //getClassDashboardData();  
                errorNotification(t('common.message.error'));
            }
        } catch (error) {
            console.error('상담여부 업데이트 실패:', error);
        }
    };

    const getTextColor = (percent: number | null) => {
        if (percent === null || isNaN(percent)) {
            return '';
        }
        return `c-${percent >= CRITERIA_ELEARNING_STATUS ? 'blue' : 'pink'}`;
    };

    const getStatusIcon = (percent: number | null) => {
        if (percent === null || isNaN(percent)) {
            return '-';
        }
        return <i className={`ic-status ${percent >= CRITERIA_ELEARNING_STATUS ? 'blue' : 'red'}`}/>;
    };

    // MT1, MT2, MT3, TT 컬럼이 필요한지 확인
    const hasMt1 = mtClinicDataList.some(item => item.mt1ExamCode);
    const hasMt2 = mtClinicDataList.some(item => item.mt2ExamCode);
    const hasMt3 = mtClinicDataList.some(item => item.mt3ExamCode);
    const hasTt = mtClinicDataList.some(item => item.ttExamCode);

    // 동적 컬럼 너비 계산
    //const baseCols = 5; // 이름, i-Coaching, e-Learning, 주당평균, 출결
    //const examCols = (hasMt1 ? 2 : 0) + (hasMt2 ? 2 : 0) + (hasMt3 ? 2 : 0) + (hasTt ? 2 : 0); // 각 시험당 점수, 상담여부
    //const clinicCols = 3; // Video, MT Review, Skill Practice
    //const totalCols = baseCols + examCols + clinicCols;

    const getAICareUrl = (studentCode: string) => {
        const careUrl = '/student/care';
        if (studentCode) {
          setAICareLog(studentCode); //CAC 로그
          window.open(careUrl + '?memberCode=' + studentCode, '_blank', 'noopener,noreferrer');
        }
    };

    const setAICareLog = (studentCode: string) => {
        const form = new FormData();
        form.append('systemDiv', 'SU');
        form.append('menuName', 'CAC');
        form.append('menuSubName', 'AI Care');
        form.append('memberCode', auth.memberCode);
        if (studentCode) {
          form.append('targetMemberCode', studentCode);
        }
        form.append('actionType', 'VIEW');
        
        creatMenuAccessLog(form).catch((error) => {
          console.error('AI Care 로그 전송 실패:', error);
        });
    }

    return (
        <>
            {isLoading ? <Loader /> : null}
            <ErrorResponse error={error} />

            <div className="comm-bx__space">
                <div className="comm-btn__area right">
                    <div className="label">
                        Status : <i className="ic-status blue"></i> 수행률 80% 이상 / <i className="ic-status red"></i> 수행률 80% 미만
                    </div>
                </div>
            </div>

            <Block className="comm-table__area mt-0">
                {mtClinicDataList && mtClinicDataList.length > 0 && 
                    <div className={hasMt1 || hasMt2 || hasMt3 || hasTt ? "table-scroll-wrapper" : ""}>
                        <table className="table-custom">
                        <colgroup>
                            <col width="8%" />
                            <col width="3%" />
                            <col width="5%" />
                            <col width="3%" />
                            <col width="5%" />
                            <col width="5%" />
                            <col width="5%" />
                            {hasMt1 && <col width="6%" />}
                            {hasMt1 && <col width="6%" />}
                            {hasMt1 && <col width="4%" />}
                            {hasMt1 && <col width="4%" />}
                            {hasMt1 && <col width="4%" />}
                            {hasMt2 && <col width="6%" />}
                            {hasMt2 && <col width="6%" />}
                            {hasMt2 && <col width="4%" />}
                            {hasMt2 && <col width="4%" />}
                            {hasMt2 && <col width="4%" />}
                            {hasMt3 && <col width="6%" />}
                            {hasMt3 && <col width="6%" />}
                            {hasTt && <col width="6%" />}
                            {hasTt && <col width="6%" />}
                        </colgroup>
                        <thead>
                            <tr>
                                <th className="text-center" rowSpan={2}>{t('class.class.column74')}</th>
                                <th className="text-center" rowSpan={2} colSpan={2}>i-Coaching Status</th>
                                <th className="text-center" rowSpan={2} colSpan={2}>e-Learning Status</th>
                                <th className="text-center" rowSpan={2}>주당 평균<br/>읽은 책 수</th>
                                <th className="text-center" rowSpan={2}>{t('class.class.column34')}</th>
                                {hasMt1 && <th className="text-center" rowSpan={2}>MT1</th>}
                                {hasMt1 && <th className="text-center" rowSpan={2}>상담여부</th>}
                                {hasMt1 && <th className="text-center" colSpan={3}>MT Clinic 수행률<br/>(Reading)</th>}
                                {hasMt2 && <th className="text-center" rowSpan={2}>MT2</th>}
                                {hasMt2 && <th className="text-center" rowSpan={2}>상담여부</th>}
                                {hasMt2 && <th className="text-center" colSpan={3}>MT Clinic 수행률<br/>(Reading)</th>}
                                {hasMt3 && <th className="text-center" rowSpan={2}>MT3</th>}
                                {hasMt3 && <th className="text-center" rowSpan={2}>상담여부</th>}
                                {hasTt && <th className="text-center" rowSpan={2}>TT</th>}
                                {hasTt && <th className="text-center" rowSpan={2}>상담여부</th>}
                            </tr>
                            <tr>
                                {hasMt1 && <th className="text-center">Video</th>}
                                {hasMt1 && <th className="text-center">MT Review</th>}
                                {hasMt1 && <th className="text-center">Skill Practice</th>}
                                {hasMt2 && <th className="text-center">Video</th>}
                                {hasMt2 && <th className="text-center">MT Review</th>}
                                {hasMt2 && <th className="text-center">Skill Practice</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {mtClinicDataList.map((item, index) => (
                                <tr key={index}>
                                    <td className="text-center">
                                        {item.memberKorName} 
                                        <span>
                                            <a 
                                                href="#" 
                                                onClick={(e) => { 
                                                    e.preventDefault(); 
                                                    getAICareUrl(item.memberCode); 
                                                }}> [AI CARE]
                                            </a>
                                        </span>
                                    </td>
                                    <td className="text-center">
                                        {getStatusIcon(item.icoachingRate)}
                                    </td>
                                    <td className={`text-center ${getTextColor(item.icoachingRate)}`}>
                                        {displayElearningPercent(item.icoachingRate)}
                                    </td>
                                    <td className="text-center">
                                        {getStatusIcon(item.elearningRate)}
                                    </td>
                                    <td className={`text-center ${getTextColor(item.elearningRate)}`}>
                                        {displayElearningPercent(item.elearningRate)}
                                    </td>
                                    <td className="text-center">{item.totalBookDaysRate || '-'}</td>
                                    <td className="text-center">
                                        {item.attendanceRate !== null && item.attendanceRate !== undefined 
                                            ? `${item.attendanceRate}%` 
                                            : '-'}
                                    </td>
                                    {hasMt1 && (
                                        <>
                                            <td className="text-center">
                                                {item.mt1Score !== null && item.mt1Score !== undefined 
                                                    ? item.mt1Score 
                                                    : '-'}
                                            </td>
                                            <td className="text-center">
                                                <Select
                                                    className="w-100p"
                                                    value={item.mt1CounselStatus || 'N'}
                                                    onChange={(value) => {
                                                        if (item.mt1ExamTestCode) {
                                                            handleCounselStatusChange(
                                                                item.classStudentCode,
                                                                item.mt1ExamTestCode,
                                                                value,
                                                                'mt1'
                                                            );
                                                        } else {
                                                            infoNotification(t('시험 생성 후 입력이 가능합니다.'));
                                                        }
                                                    }}
                                                >
                                                    {CL0007?.map((code) => (
                                                        <Option key={code.detailCode} value={code.detailCode}>
                                                            {i18n.language === 'ko' ? code.korName : code.engName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </td>
                                            <td className="text-center">{item.mt1VideoDisplay || '-'}</td>
                                            <td className="text-center">{item.mt1ReviewDisplay || '-'}</td>
                                            <td className="text-center">{item.mt1SkillPracticeDisplay || '-'}</td>
                                        </>
                                    )}
                                    {hasMt2 && (
                                        <>
                                            <td className="text-center">
                                                {item.mt2Score !== null && item.mt2Score !== undefined 
                                                    ? item.mt2Score 
                                                    : '-'}
                                            </td>
                                            <td className="text-center">
                                                <Select
                                                    className="w-100p"
                                                    value={item.mt2CounselStatus || 'N'}
                                                    onChange={(value) => {
                                                        if (item.mt2ExamTestCode) {
                                                            handleCounselStatusChange(
                                                                item.classStudentCode,
                                                                item.mt2ExamTestCode,
                                                                value,
                                                                'mt2'
                                                            );
                                                        } else {
                                                            infoNotification(t('시험 생성 후 입력이 가능합니다.'));
                                                        }
                                                    }}
                                                >
                                                    {CL0007?.map((code) => (
                                                        <Option key={code.detailCode} value={code.detailCode}>
                                                            {i18n.language === 'ko' ? code.korName : code.engName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </td>
                                            <td className="text-center">{item.mt2VideoDisplay || '-'}</td>
                                            <td className="text-center">{item.mt2ReviewDisplay || '-'}</td>
                                            <td className="text-center">{item.mt2SkillPracticeDisplay || '-'}</td>
                                        </>
                                    )}
                                    {hasMt3 && (
                                        <>
                                            <td className="text-center">
                                                {item.mt3Score !== null && item.mt3Score !== undefined 
                                                    ? item.mt3Score 
                                                    : '-'}
                                            </td>
                                            <td className="text-center">
                                                <Select
                                                    className="w-100p"
                                                    value={item.mt3CounselStatus || 'N'}
                                                    onChange={(value) => {
                                                        if (item.mt3ExamTestCode) {
                                                            handleCounselStatusChange(
                                                                item.classStudentCode,
                                                                item.mt3ExamTestCode,
                                                                value,
                                                                'mt3'
                                                            );
                                                        } else {
                                                            infoNotification(t('시험 생성 후 입력이 가능합니다.'));
                                                        }
                                                    }}
                                                >
                                                    {CL0007?.map((code) => (
                                                        <Option key={code.detailCode} value={code.detailCode}>
                                                            {i18n.language === 'ko' ? code.korName : code.engName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </td>
                                        </>
                                    )}
                                    {hasTt && (
                                        <>
                                            <td className="text-center">
                                                {item.ttScore !== null && item.ttScore !== undefined 
                                                    ? item.ttScore 
                                                    : '-'}
                                            </td>
                                            <td className="text-center">
                                                <Select
                                                    className="w-100p"
                                                    value={item.ttCounselStatus || 'N'}
                                                    onChange={(value) => {
                                                        if (item.ttExamTestCode) {
                                                            handleCounselStatusChange(
                                                                item.classStudentCode,
                                                                item.ttExamTestCode,
                                                                value,
                                                                'tt'
                                                            );
                                                        } else {
                                                            infoNotification(t('시험 생성 후 입력이 가능합니다.'));
                                                        }
                                                    }}
                                                >
                                                    {CL0007?.map((code) => (
                                                        <Option key={code.detailCode} value={code.detailCode}>
                                                            {i18n.language === 'ko' ? code.korName : code.engName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                }
            </Block>
        </>
    )
}

export default Management;